<div class="delete-order-dialog">
  <header class="dialog-header dialog-header--danger">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>delete_outline</mat-icon>
    </div>
    <div class="dialog-header__text">
      <h2 mat-dialog-title>Eliminar Orden de Servicio</h2>
      <p *ngIf="contextLabelString" class="dialog-header__context">
        {{ contextLabelString }}
      </p>
    </div>
  </header>

  <mat-dialog-content class="dialog-body" *ngIf="viewState === 'confirm'">
    <div class="summary-card summary-card--danger">
      <div class="summary-card__count">N°</div>
      <div class="summary-card__info">
        <strong>{{ targetOrderNumber || "—" }}</strong>
        <span>{{ displayedServiceName }} · {{ displayedProviderName }}</span>
      </div>
      <span [ngClass]="statusBadgeClass">{{
        currentOrderStatus || "—"
      }}</span>
    </div>

    <ul class="os-meta" *ngIf="currentReservationNumber || currentReservationStatus">
      <li *ngIf="currentReservationNumber">
        Reserva: {{ currentReservationNumber }}
      </li>
      <li *ngIf="currentReservationStatus">
        Estado reserva: {{ currentReservationStatus }}
      </li>
    </ul>

    <p *ngIf="affectedServicesCount > 1" class="impact-note">
      Se liberarán <strong>{{ affectedServicesCount }} servicios</strong> vinculados
      a esta OS.
    </p>

    <div class="alert alert--warn">
      <mat-icon>warning_amber</mat-icon>
      <span>
        Esta acción es irreversible. El servicio quedará disponible para generar
        una nueva OS.
      </span>
    </div>
  </mat-dialog-content>

  <mat-dialog-content
    class="dialog-body dialog-body--center"
    *ngIf="viewState === 'loading'"
  >
    <mat-spinner [diameter]="40"></mat-spinner>
    <p class="state-title">Eliminando Orden de Servicio</p>
    <p class="state-subtitle">N° {{ targetOrderNumber }}</p>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="viewState === 'error'">
    <div class="alert alert--error">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong *ngIf="displayedErrorTitleText">{{
          displayedErrorTitleText
        }}</strong>
        <span>{{ displayedErrorMessageText }}</span>
      </div>
    </div>
    <p *ngIf="doesErrorRequireTableRefresh" class="impact-note">
      La grilla puede estar desactualizada. Al continuar se consultará de nuevo
      el backend.
    </p>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="viewState === 'blocked'">
    <div class="alert alert--error">
      <mat-icon>block</mat-icon>
      <span>{{ blockedMessage }}</span>
    </div>

    <div class="summary-card summary-card--muted">
      <div class="summary-card__count">N°</div>
      <div class="summary-card__info">
        <strong>{{ targetOrderNumber || "—" }}</strong>
        <span>{{ displayedServiceName }}</span>
      </div>
      <span [ngClass]="statusBadgeClass">{{
        currentOrderStatus || "—"
      }}</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions" *ngIf="viewState === 'confirm'">
    <button
      mat-stroked-button
      type="button"
      class="do-btn do-btn--ghost"
      (click)="cancel()"
    >
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="do-btn do-btn--danger"
      (click)="confirmDelete()"
    >
      Eliminar OS
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions
    class="dialog-actions"
    *ngIf="viewState === 'error' && !doesErrorRequireTableRefresh"
  >
    <button
      mat-stroked-button
      type="button"
      class="do-btn do-btn--ghost"
      (click)="cancel()"
    >
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="do-btn do-btn--danger"
      (click)="retry()"
    >
      Reintentar
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions
    class="dialog-actions"
    *ngIf="viewState === 'error' && doesErrorRequireTableRefresh"
  >
    <button
      mat-flat-button
      type="button"
      class="do-btn do-btn--primary"
      (click)="cerrarYActualizar()"
    >
      Entendido y actualizar
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions class="dialog-actions" *ngIf="viewState === 'blocked'">
    <button
      mat-flat-button
      type="button"
      class="do-btn do-btn--primary"
      (click)="dismissBlocked()"
    >
      Entendido
    </button>
  </mat-dialog-actions>
</div>
